import { render, staticRenderFns } from "./ProductDetailPopup.vue?vue&type=template&id=60a86c13&scoped=true&"
import script from "./ProductDetailPopup.vue?vue&type=script&lang=js&"
export * from "./ProductDetailPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailPopup.vue?vue&type=style&index=0&id=60a86c13&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a86c13",
  null
  
)

export default component.exports